import actions from '../../../actions'

export default {
  header: [
    { ...actions.addNewAggregateType, create: true }
  ],
  table: {
    noApi: true,
    specialFlag: {
      aggregate: true,
      endpoint: 'debrisTypes',
      departmentId: undefined
    },
    sorting: {
      sortBy: 'id',
      sortDesc: true
    },
    parameters: [
      { name: 'id', text: 'Nr pozycji', value: 'id', show: true },
      { name: 'createdAt', text: 'Data utworzenia', value: 'createdAt', show: true },
      { name: 'displayName', text: 'Typ kruszywa', value: 'displayName', show: true },
      { name: 'visibleForDriver', text: 'Widoczne dla kierowcy', value: 'visibleForDriver', show: true },
      { name: 'active', text: 'Aktywny', value: 'active', show: true },
      { name: 'actions', text: '', value: 'actions', sortable: false, show: true }
    ],
    actions: [
      { ...actions.deleteAggregateType, icon: 'usun' }
    ],
    menu: [
      { ...actions.deleteAggregateType }
    ]
  },
  details: {
    title: 'Typ kruszywa {{code}}',
    actions: [
      { ...actions.deleteAggregateType, redirect: true }
    ],
    sections: [
      {
        name: 'general',
        text: 'Informacje ogólne',
        type: 'left',
        endpoint: 'debrisTypes',
        fields: [
          { name: 'id', text: 'Nr pozycji', value: 'id', type: 'inline', col: 3 },
          { name: 'createdAt', text: 'Data utworzenia', value: 'createdAt', type: 'inline', col: 3 },
          { name: 'visibleForDriver', text: 'Widoczne dla kierowcy', value: 'visibleForDriver', type: 'boolean', col: 3, editable: true, rules: ['required'] },
          { name: 'active', text: 'Aktywny', value: 'active', type: 'boolean', col: 3, editable: true, rules: ['required'] },
          { name: 'displayName', text: 'Typ kruszywa', value: 'displayName', type: 'textField', col: 12, editable: true, rules: ['required'] },
          { name: 'clientDisplayName', text: 'Nazwa widoczna przez klienta', value: 'clientDisplayName', type: 'textField', col: 12, editable: true },
        ]
      },
    ]
  }
}
